import { render, staticRenderFns } from "./pairings.vue?vue&type=template&id=3c18d6cf&"
import script from "./pairings.vue?vue&type=script&lang=js&"
export * from "./pairings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports